import { useState } from "react";
import "./_OrderSideNav.scss";
import "./_OrderSideNavMobile.scss";
import { useAppContext } from "../../../../../Components/AppProvider";
import { setRedirect } from "../../../utils/_redirect";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function _OrderSideNav({
  sidenavstructure,
  activeSideNav,
  setActiveSideNav,
  statusCountList,
}) {
  const countMap = {
    "UNPAID ORDERS": statusCountList.unpaidCount || 0,
    "PENDING APPROVALS": statusCountList.pendingCount || 0,
    "PARTIALLY PAID": statusCountList.partialCount || 0,
    "FULLY PAID": statusCountList.paidCount || 0, // ✅ removed trailing space
    "READY TO SHIP": statusCountList.ready2shipCount || 0,
    SHIPPED: statusCountList.shippedCount || 0,
    COMPLETED: statusCountList.completedCount || 0,
    DECLINED: statusCountList.declinedCount || 0,
    CANCELLED: statusCountList.cancelledCount || 0,
    REFUNDED: statusCountList.refundedCount || 0,
  };

  // ✅ Use array instead of object
  const itemNames = [
    "unpaid",
    "pending",
    "partial",
    "fully",
    "ready",
    "shipped",
    "completed",
    "declined",
    "cancelled",
    "refunded",
  ];

  const { setCountListUpdate } = useAppContext();

  const [open, setOpen] = useState(false);
  return (
    <>
      {" "}
      {/* Toggle button (mobile) */}
      <button
        className={`prod-sidenav-toggle ${open ? "open" : "closed"}`}
        onClick={() => setOpen((s) => !s)}
        aria-expanded={open}
        aria-label={open ? "Close sidebar" : "Open sidebar"}
      >
        {open ? <FaChevronLeft /> : <FaChevronRight />}
      </button>
      <aside className={`ad-order-sidenav-container ${open ? "open" : ""}`}>
        {sidenavstructure.map((item, index) => (
          <div
            className={`order-sidenav-item-wrapper ${
              activeSideNav === index ? "activeSideNav" : ""
            }`}
            key={index}
            onClick={() => {
              setActiveSideNav(index);
              setCountListUpdate((prev) => !prev);
              setRedirect(3, index);
            }}
          >
            <span>{item}</span>
            <div className={`count ${itemNames[index]}`}>
              {countMap[item] ?? 0}
            </div>
          </div>
        ))}
      </aside>
    </>
  );
}
